var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"user-groups"},[_c('img',{staticClass:"user-groups__image",attrs:{"src":_vm.currentUser.user_group.image_url}})])}
var staticRenderFns = []

export { render, staticRenderFns }